// @flow
import React from 'react';
import { connect } from 'react-redux';

// import type { ROUTE_STOP_TYPE } from '../../types/routes';
import { transformTime, getMeridian } from '../../lib/time';
import ThreePartResultDummy from '../ThreePartResultDummy';
import * as routesActions from '../../actions/routes';
import ETADisplay from '../ETADisplay';
import * as selectors from '../../reducers';
// import * as mapsActions from '../../actions/map';
import styles from './routeStop.css';

// TODO: TRANSFORMAR ETA DE NUMERO A STRING CON FORMATO DE HORAS HUMANO
type RouteStopPropTypes = {
  id: number,
  name: string,
  isNext: boolean,
  isLast: boolean,
  isDestiny: boolean,
  tripStop: Object,
  eta: number,
  selectedRouteStopId: number,
  onClick: Object => mixed
};

const RouteStop = ({
  name = '',
  isNext = false,
  isLast = false,
  isDestiny = false,
  tripStop,
  selectedRouteStopId,
  onClick,
  eta,
  id,
  ...routeStop
}: RouteStopPropTypes) => (
  <div className={styles.routeStop}>
    <ThreePartResultDummy
      label={
        `
          ${isNext ? 'Siguiente parada' : ''}
          ${isLast ? 'Última parada' : ''}
          ${isDestiny ? 'Destino' : ''}
        `
      }
      title={name}
      rightIndicator=""
      className="medium"
      isSelected={id === selectedRouteStopId}
      onClick={() => onClick({
        ...routeStop,
        id,
        eta,
        name,
        isNext,
        isLast,
        isDestiny,
      })}
      hasHandle
    />
    <ETADisplay
      isSelected={id === selectedRouteStopId}
      eta={tripStop ? tripStop.eta : (eta ? eta : 'N/A')}
      isCompleted={tripStop ? tripStop.is_completed : false}
    />
  </div>
);

export default connect(
  (state, ownProps) => ({
    tripStop: selectors.getTripStopFromRouteStop(state, ownProps.id),
  }),
  dispatch => ({
    onClick(rs) {
      dispatch(routesActions.setCurrentRouteStop(rs.id));
    },
  }),
)(RouteStop);



// WEBPACK FOOTER //
// ./src/scripts/components/RouteStop/index.jsx